/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicableCertificate
 */
export interface ApplicableCertificate {
    /**
     * 
     * @type {string}
     * @memberof ApplicableCertificate
     */
    certificateType: ApplicableCertificateCertificateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ApplicableCertificate
     */
    remainingCount: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplicableCertificate
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicableCertificate
     */
    programName: string;
}


/**
 * @export
 */
export const ApplicableCertificateCertificateTypeEnum = {
    Nua: 'nua',
    Sua: 'sua',
    Cur: 'cur',
    IhgSuiteUpgrade: 'ihg_suite_upgrade'
} as const;
export type ApplicableCertificateCertificateTypeEnum = typeof ApplicableCertificateCertificateTypeEnum[keyof typeof ApplicableCertificateCertificateTypeEnum];


/**
 * Check if a given object implements the ApplicableCertificate interface.
 */
export function instanceOfApplicableCertificate(value: object): value is ApplicableCertificate {
    if (!('certificateType' in value) || value['certificateType'] === undefined) return false;
    if (!('remainingCount' in value) || value['remainingCount'] === undefined) return false;
    if (!('programName' in value) || value['programName'] === undefined) return false;
    return true;
}

export function ApplicableCertificateFromJSON(json: any): ApplicableCertificate {
    return ApplicableCertificateFromJSONTyped(json, false);
}

export function ApplicableCertificateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicableCertificate {
    if (json == null) {
        return json;
    }
    return {
        
        'certificateType': json['certificate_type'],
        'remainingCount': json['remaining_count'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'programName': json['program_name'],
    };
}

export function ApplicableCertificateToJSON(json: any): ApplicableCertificate {
    return ApplicableCertificateToJSONTyped(json, false);
}

export function ApplicableCertificateToJSONTyped(value?: ApplicableCertificate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'certificate_type': value['certificateType'],
        'remaining_count': value['remainingCount'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'program_name': value['programName'],
    };
}

